module.exports = "/_next/static/images/233c8c6f3fde8d754e5ebe08b33b434c-boy-looking-to-the-front@1x.jpg.webp";